import React from "react"
import autobind from "class-autobind"
import { TextField, RaisedButton } from "material-ui"
import * as accountActions from "../../actions/AccountActions"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
import Address from "../../components/address/Address"
import { IAddress } from "../../models"
import AppStateStore from "../../stores/AppStateStore"

interface IProps {

}
interface IState {
    contactName: string
    errorContactName: string
    contactEmail: string
    emailErrorText: string
    address: IAddress
}


export default class AccountInfoForm extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const account = AccountStore.getCurrentAccount()
        this.state = {
            contactName: account.AccountSettings.ContactName || "",
            errorContactName: "",
            contactEmail: account.AccountSettings.ContactEmail || "",
            emailErrorText: "",
            address: account.BillingInfo.Address,
        }
        autobind(this)
    }

    saveAccount() {
        if (!this.validateForm()) return

        const account = AccountStore.getCurrentAccount()
        accountActions.patchAccountBillingContact(
            account.Id,
            {
                AccountSettings: {
                    ContactName: this.state.contactName.trim(),
                    ContactEmail: this.state.contactEmail
                },
                BillingInfo: {
                    PerEmployeePerMonthRate: account.BillingInfo.PerEmployeePerMonthRate,
                    PerClockPerMonthRate: account.BillingInfo.PerClockPerMonthRate,
                    Address: this.state.address
                }
            },
            () => AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
        )
    }

    validateForm() {
        let returnVal = true
        const emailRegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (this.state.contactEmail.match(emailRegExp)) {
            this.setState({ emailErrorText: "" })
        } else {
            this.setState({ emailErrorText: "Invalid email." })
            returnVal = false
        }

        if (!this.state.contactName.trim()) {
            this.setState({ errorContactName: strings.This_field_is_required })
            returnVal = false
        }
        else {
            this.setState({ errorContactName: "" })
        }
        return returnVal
    }

    handleAddress(address: IAddress) {
        this.setState({ address: { ...this.state.address, ...address } })
    }

    render() {
        return (
            <div className="AccountInfoForm">
                <h3 style={{ padding: "20px 20px 0 20px" }}>
                    {AccountStore.getCurrentAccount().Name}
                </h3>
                <div style={{ marginLeft: 20 }}>
                    <TextField
                        style={{ width: "80%" }}
                        floatingLabelText={strings.Contact_Name}
                        value={this.state.contactName}
                        onChange={e => this.setState({ contactName: e.target.value }, () => this.validateForm())}
                        errorText={this.state.errorContactName}
                    />
                    <TextField
                        style={{ width: "80%" }}
                        floatingLabelText={strings.Contact_Email}
                        value={this.state.contactEmail}
                        onChange={e => this.setState({ contactEmail: e.target.value }, () => this.validateForm())}
                        errorText={this.state.emailErrorText}
                        type="email"
                    />
                    <Address readonly={false} address={this.state.address} handleAddress={this.handleAddress} showLatLng={false} />
                    <RaisedButton
                        label={"Save"}
                        secondary
                        style={{ marginTop: 15 }}
                        onTouchTap={() => this.saveAccount()}
                    />
                </div>
            </div>
        )
    }
}